<template>
  <div class="menu dinline-block vtop fs14 pl35">
    <div class="cont tleft pt30 pl35">
      <div class="fs24 tcenter pl20 pr20">{{info.title}}</div>
      <div class="tc-enred fs16 tcenter mt20">
        <span class="mr35">浏览：{{info.view_count}}</span>
        <span>发布时间：{{info.created_at}}</span>
      </div>
      <div class="ncont tc6 fs16 lh20" v-html="info.content">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  data(){
    return {
      info:{},
      msg:'',
    }
  },
  created() {
  },
  watch:{
    $route:{
      deep:true,
      immediate:true,
      handler:function (n,o) {
        this.updateData();
      }
    }
  },
  methods:{
    backTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    updateData(){
      this.id = this.$route.query.id
      this.pid = this.$route.query.pid
      this.backTop();
      this.getData();
    },
    getData(){
      var getParam = {}
      var id = this.$route.query['article_id']
      getParam['id'] = id
      this.$request.get('recruit-article/detail',getParam,response => {
        if(response.status == 200){
          if(response.data.code != 200){
            this.msg = response.data.message;
          }else{
            let res = response.data.data
            this.info = res
          }
        }else{
          this.msg = '请求失败';
        }
        console.log(1)
        console.log(this.info)
      },error => {
        console.log(error)
      })
    },
  },
}
</script>

<style scoped>
  .menu{width: 930px;margin-top: 0;}
  .ncont{padding: 40px 35px;line-height: 2.2;}
</style>



// WEBPACK FOOTER //
// src/pages/enroll/detail.vue